import Button from "@mui/material/Button/Button"
import { height } from "@mui/system"
import { Observer, observer } from "mobx-react-lite"
import { useEffect } from "react"
import { DumpUserItem } from "../components/DumpUserItem"
import { rootStore } from "../StApp"
import { motion } from "framer-motion";
import { Transitions } from "../transitions/pageTransitions";


const DumpList = observer(() => {

    const store = rootStore.dumpStore

    return (
        <div style={{ overflow: 'scroll', height: '100%' }} >
            <ul style={{ marginBottom: 0 }} >
                {store.dumpUsers.map(item => <DumpUserItem key={item.uid} user={item} />)}
            </ul>
        </div>);
})


const DumpPlay = () => {

    const store = rootStore.dumpStore

    return (
        <motion.div className='flex-column absolute ' style={{ height: '100%', width: '100%' }}
            initial="initial"
            animate="in"
            exit="out"
            variants={Transitions.pageVariants}
            transition={Transitions.pageTransition}
        >
            <div className='flex-column center-both ' style={{ backgroundColor: 'purple', color: 'white' }} >
                <h3 style={{ marginBottom: 5 }} >Your Dumps</h3>
                <p style={{ marginBottom: 18 }} >Make the heart or Break the heart, again ;)</p>
            </div>
            <div className='relative' style={{ flexGrow: 1, overflow: 'hidden' }} >
                <DumpList />
            </div>
            <div className='flex-row bottom-nav-bar-dump ' style={{ justifyContent: 'flex-end', padding: 10 }} >
                <Observer>{() => <button
                    className='button-styled button-dump '
                    style={{ marginRight: 20 }}
                    disabled={store.finalDumpUids.size + store.likedUids.size == 0}
                    onClick={() => store.confirmChoice()}
                >Confirm</button>}</Observer>
            </div>
        </motion.div>
    )
}

export default DumpPlay